export class ClientContact {
    id: number;
    streetNO: string;
    streetNM: string;
    streetDirectionNM: string;
    streetTypeNM: string;
    apartmentId: string;
    city: string;
    state: string;
    zip: string;

    constructor(clientContact: any) {
        if (clientContact) {
            this.id = clientContact.id;
            this.streetNO = clientContact.streetNO;
            this.streetNM = clientContact.streetNM;
            this.streetDirectionNM = clientContact.streetDirectionNM;
            this.streetTypeNM = clientContact.streetTypeNM;
            this.apartmentId = clientContact.apartmentId;
            this.city = clientContact.city;
            this.state = clientContact.state;
            this.zip = clientContact.zip;
        }
    }
}
